import React, { Component } from 'react';
import moment from 'moment';
import InputMask from 'react-input-mask';
import { FaQuestion } from 'react-icons/fa';
import creditCardType from 'credit-card-type';
import { FiAlertCircle } from 'react-icons/fi';
import FormField from '../../style/styledComponents/FormField';
import * as yup from 'yup';
import { Field, Form, Formik, useField } from 'formik';
import TermAndConditions from '../../Components/TermAndConditions';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import 'react-credit-cards/lib/styles.scss';

class FormCreditCard extends Component {
	constructor() {
		super();

		this.state = {
			cardNumber: '',
			cardName: '',
			cardExpiry: '',
			cardExpirationMonth: '',
			cardExpirationYear: '',
			cardCVV: '',
			numberOfInstallment: '',
			maskCard: '9999 9999 9999 9999',
			maskCvv: '9999',
			flagIcon: 'form-control',
			termos: false,
			termos1: false,
			focus: ''
		};

		this.initialValues = this.state;
		this.setField = this.setField.bind(this);
		this.goBack = this.goBack.bind(this);
		this.sendPaymentForm = this.sendPaymentForm.bind(this);
		this.changeTerm = this.changeTerm.bind(this);
	}
	componentDidMount() {
		if (this.props.installments) {
			this.setState({
				numberOfInstallment: this.props.installments
			});
			this.initialValues.numberOfInstallment = this.props.installments;
		}
		if (window.jQuery) {
			let $ = window.jQuery;
			$('[data-toggle="tooltip"]').tooltip();
		}
	}

	checkField(name, value) {
		let fieldChecked = false;
		let checkField = {
			cardNumber: /^([0-9]{16})|(3[47][0-9]{13})$/i,
			cardName: /^([\s]?([a-zà-ú])+\s)+([a-zà-ú])+[\s]?$/i,
			cardExpirationMonth: /^(1[0-2])|(0[1-9])$/i,
			cardExpirationYear: /^(2[0])([2-9][0-9])$/i,
			cardExpiry: /^((1[0-2])|(0[1-9]))\/([2-9][0-9])$/i,
			cardCVV: /^([0-9]{3,4})$/i
		};

		if (checkField[name]) {
			if (checkField[name].test(value)) {
				switch (name) {
					case 'cardNumber':
						if (this.state.flagIcon !== 'form-control') {
							fieldChecked = true;
						}
						break;
					case 'cardExpiry':
						let dateValue = moment(value, 'MM/YY');
						let currentDate = moment();
						let passLimitDate = moment(dateValue).isAfter(currentDate);
						if (passLimitDate) {
							fieldChecked = true;
						}
						break;
					case 'cardCVV':
						if (value.length === this.state.maskCvv.length) {
							fieldChecked = true;
						}
						break;
					default:
						fieldChecked = true;
						break;
				}
			}
		} else {
			if (name === 'termos1' || name === 'termos') {
				fieldChecked = value;
			} else {
				fieldChecked = true;
			}
		}

		return fieldChecked;
	}

	removeAcento(text) {
		text = text.replace(new RegExp('[ÁÀÂÃ]', 'g'), 'A');
		text = text.replace(new RegExp('[ÉÈÊ]', 'g'), 'E');
		text = text.replace(new RegExp('[ÍÌÎ]', 'g'), 'I');
		text = text.replace(new RegExp('[ÓÒÔÕ]', 'g'), 'O');
		text = text.replace(new RegExp('[ÚÙÛ]', 'g'), 'U');
		text = text.replace(new RegExp('[Ç]', 'g'), 'C');
		text = text.replace(new RegExp('[áàâã]', 'g'), 'a');
		text = text.replace(new RegExp('[éèê]', 'g'), 'e');
		text = text.replace(new RegExp('[íìî]', 'g'), 'i');
		text = text.replace(new RegExp('[óòôõ]', 'g'), 'o');
		text = text.replace(new RegExp('[úùû]', 'g'), 'u');
		text = text.replace(new RegExp('[ç]', 'g'), 'c');

		return text;
	}

	sendPaymentForm() {
		let inputData = this.state;
		let error = false;
		for (var fieldName in inputData) {
			if (!this.checkField(fieldName, inputData[fieldName])) {
				error = true;
			}
		}
		const hasError = error;
		this.props.notSend();
		if (!hasError) {
			this.props.onSend();
		}
	}

	removeWhiteSpace(text) {
		text = text.replace(/ /g, '');
		text = text.replace(/_/g, '');
		return text;
	}

	removeCardNameWhiteSpace(e, setFieldValue) {
		if (this.checkField('cardName', e.target.value)) {
			let value = e.target.value.trim();

			setFieldValue('cardName', value);
			this.setState(
				{
					cardName: value
				},
				() => {
					this.props.isCompleted(!this.state.termos);
				}
			);
		}
	}

	goBack() {
		this.props.history.goBack();
	}

	renderSwitch(focus) {
		let name = '';
		switch (focus) {
			case 'cardNumber':
				name = 'number';
				break;
			case 'cardCVV':
				name = 'cvc';
				break;
			case 'cardName':
				name = 'name';
				break;
			case 'cardExpiry':
				name = 'expiry';
				break;
			default:
				name = focus;
		}
		return name;
	}

	creditCardFlagIcon = value => {
		let creditCardFlag = 'form-control';

		if (value.length > 2) {
			let creditCardVisaFlags = 'form-control credit_card_visa_flag';
			let creditCardMasterCardFlags =
				'form-control credit_card_mastercard_flag';
			let creditCardEloFlags = 'form-control credit_card_elo_flag';
			let creditCardHipercardFlags = 'form-control credit_card_hipercard_flag';
			let creditdCardAmericanExpress =
				'form-control credit_card_american_express_flag';

			let card = creditCardType(this.state.cardNumber).filter(card => {
				return card;
			});

			if (card.length > 1 || typeof card[0] === 'undefined') {
				return (creditCardFlag = 'form-control');
			}

			if (card[0].type === 'visa') {
				let maskCvv = card[0].code.size === 3 ? '999' : '9999';
				this.setState({
					maskCvv: maskCvv
				});
				creditCardFlag = creditCardVisaFlags;
			} else if (card[0].type === 'mastercard') {
				let maskCvv = card[0].code.size === 3 ? '999' : '9999';
				this.setState({
					maskCvv: maskCvv
				});
				creditCardFlag = creditCardMasterCardFlags;
			} else if (card[0].type === 'hipercard') {
				let maskCvv = card[0].code.size === 3 ? '999' : '9999';
				this.setState({
					maskCvv: maskCvv
				});
				creditCardFlag = creditCardHipercardFlags;
			} else if (card[0].type === 'elo') {
				let maskCvv = card[0].code.size === 3 ? '999' : '9999';
				this.setState({
					maskCvv: maskCvv
				});
				creditCardFlag = creditCardEloFlags;
			} else if (card[0].type === 'american-express') {
				let maskCvv = card[0].code.size === 3 ? '999' : '9999';
				this.setState({
					maskCvv: maskCvv
				});
				creditCardFlag = creditdCardAmericanExpress;
			} else {
				creditCardFlag = 'form-control';
			}
		}
		return creditCardFlag;
	};

	changeTerm(e, setFieldValue) {
		const isChecked = this.state.termos ? true : false;
		setFieldValue('termos1', e.target.checked);
		setFieldValue('termos', e.target.checked);
		this.setState(
			{
				termos: e.target.checked,
				termos1: e.target.checked
			},
			() => {
				this.props.isCompleted(isChecked);
			}
		);
	}

	setField(e, setFieldValue) {
		let value = e.target.value;
		let name = e.target.getAttribute('name');
		let stateObj = {};

		if (name === 'cardExpiry') {
			let splitValue = value.split('/');
			stateObj['cardExpirationMonth'] = splitValue[0];
			stateObj['cardExpirationYear'] = '20' + splitValue[1];
			setFieldValue(name, value);
			setFieldValue('cardExpirationMonth', stateObj['cardExpirationMonth']);
			setFieldValue('cardExpirationYear', stateObj['cardExpirationYear']);
		}

		if (name === 'cardName') {
			value = value.replace(/( )+/g, ' ');
			setFieldValue(name, value);
		}

		if (name === 'cardNumber') {
			let newFlagIcon = this.creditCardFlagIcon(value);
			setFieldValue('flagIcon', newFlagIcon);
			setFieldValue('maskCvv', this.state.maskCvv);
			this.setState({ flagIcon: newFlagIcon });

			if (/^3[47]/.test(value)) {
				stateObj['maskCard'] = '9999 999999 99999';
				stateObj[name] = this.removeWhiteSpace(value);
			} else {
				stateObj['maskCard'] = '9999 9999 9999 9999';
				stateObj[name] = this.removeWhiteSpace(value);
			}

			setFieldValue('maskCard', stateObj['maskCard']);
			setFieldValue(name, stateObj[name]);

			if (/^(\d\d\d)/.test(value)) {
				stateObj['cardCVV'] = '';
				setFieldValue('cardCVV', '');
			}
		} else {
			stateObj[name] = value;
			setFieldValue(name, stateObj[name]);
		}

		this.setState(stateObj, () => {
			this.props.isCompleted(!this.state.termos);
		});
	}

	handleInputFocus = e => {
		this.setState({ focus: e.target.name });
	};

	getData() {
		let inputData = this.state;
		let dataSend = {};

		for (var fieldName in inputData) {
			if (this.checkField(fieldName, inputData[fieldName])) {
				let value = inputData[fieldName];

				if (fieldName === 'cardName') {
					value = this.removeAcento(value);
				}

				dataSend[fieldName] = value;
			} else {
				dataSend[fieldName] = undefined;
			}
		}

		return dataSend;
	}

	render() {
		let { SignatureChosen } = this.props;
		const validationSchema = yup.object().shape({
			cardName: yup
				.string('Insira o nome impresso no cartão')
				.required('Insira o nome impresso no cartão')
				.test('validCardName', 'Nome inválido', function(e) {
					let validCardName = true;
					if (!/^([\s]?([a-zà-ú])+\s)+([a-zà-ú])+[\s]?$/i.test(e)) {
						validCardName = false;
					}
					return validCardName;
				}),
			cardNumber: yup
				.string('Insira o número do cartão')
				.required('Insira o número do cartão')
				.test('notEmptyCardNumber', 'Insira o número do cartão', function(e) {
					let notEmptyCardNumber = true;
					if (e === '____ ____ ____ ____') {
						notEmptyCardNumber = false;
					}
					return notEmptyCardNumber;
				})
				.test('validCardNumber', 'Número do cartão inválido', function(e) {
					let validCardNumber = true;
					if (!/^([0-9]{16})|(3[47][0-9]{13})$/i.test(e)) {
						validCardNumber = false;
					}
					return validCardNumber;
				})
				.test('acceptCardNumber', 'Este cartão não é aceito', function(e) {
					let acceptCardNumber = true;
					if (this.parent.flagIcon === 'form-control') {
						acceptCardNumber = false;
					}
					return acceptCardNumber;
				}),
			cardExpiry: yup
				.string('Insira a validade')
				.required('Insira a validade')
				.test('notEmptyCardExpiry', 'Insira a validade', function(e) {
					let notEmptyCardExpiry = true;
					if (e === '__/__') {
						notEmptyCardExpiry = false;
					}
					return notEmptyCardExpiry;
				})
				.test('validMonth', 'Validade do cartão inválida', function(e) {
					let validMonth = true;
					if (e) {
						let splitValue = e.split('/');
						if (!/^(1[0-2])|(0[1-9])$/i.test(splitValue[0])) {
							validMonth = false;
						}
					}
					return validMonth;
				})
				.test('validYear', 'Validade do cartão inválida', function(e) {
					let validYear = true;
					if (e) {
						let splitValue = e.split('/');
						if (!/^(2[0])([2-9][0-9])$/i.test('20' + splitValue[1])) {
							validYear = false;
						}
					}
					return validYear;
				})
				.test('afterCurrentDate', 'Validade do cartão inválida', function(e) {
					let afterCurrentDate = true;
					let dateValue = moment(e, 'MM/YY');
					let currentDate = moment();
					let passLimitDate = moment(dateValue).isAfter(currentDate);
					if (!passLimitDate) {
						afterCurrentDate = false;
					}
					return afterCurrentDate;
				}),
			cardCVV: yup
				.string('Insira código CVV')
				.required('Insira código CVV')
				.test('validCardCVV', 'CVV do cartão inválido', function(e) {
					let validCardCVV = true;
					if (!/^([0-9]{3,4})$/i.test(e)) {
						validCardCVV = false;
					} else {
						if (e.length !== this.parent.maskCvv.length) {
							validCardCVV = false;
						}
					}
					return validCardCVV;
				}),
			numberOfInstallment: yup.string().required(),
			termos1: yup
				.boolean('É necessário aceitar os termos para continuar')
				.required('É necessário aceitar os termos para continuar')
				.test(
					'validTermos1',
					'É necessário aceitar os termos para continuar',
					function(e) {
						let validTermos1 = true;
						if (!e) {
							validTermos1 = false;
						}
						return validTermos1;
					}
				)
		});

		this.props.onData(this.getData());

		const currencyFormat = new Intl.NumberFormat('pt-BR', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});

		let installments = [];
		var totalValue = this.props.totalValue;

		for (let i = 0; i < this.props.installments; i++) {
			var value = i + 1;
			var label = '';
			var installmentValue = totalValue / value;
			if (value === 1) {
				label = '1x de R$ ' + currencyFormat.format(installmentValue);
			} else {
				label =
					`${value}x de R$ ` +
					currencyFormat.format(installmentValue) +
					` sem juros`;
			}

			let props = {};

			installments.push(
				<option key={i} value={value} {...props}>
					{label}
				</option>
			);
		}
		let installmentElm = '';

		if (installments.length > 1) {
			installmentElm = ({ values, setFieldValue, handleBlur }) => {
				return (
					<FormField>
						<FormField className='form-select'>
							<Field
								className='form-control'
								id='installments'
								name='numberOfInstallment'
								as='select'
								onChange={e => {
									this.setField(e, setFieldValue);
								}}
								onBlur={handleBlur}
								value={values.numberOfInstallment}
								required>
								{installments}
							</Field>
							<label htmlFor='installments'>Parcelamento</label>
						</FormField>
					</FormField>
				);
			};
		}
		const { loja } = this.props.match.params;

		const planType = sessionStorage.getItem('planType');
		const dependentIsActive = sessionStorage.getItem('dependentIsActive');
		let title = planType.trim();
		if (this.props.cardPayment) {
			this.sendPaymentForm();
		}

		return (
			<div role='tabpanel' className='tab-pane active' id='cartao'>
				<Formik
					initialValues={this.initialValues}
					validationSchema={validationSchema}
					validateOnChange
					validateOnBlur
					validateOnMount
					enableReinitialize
					onSubmit={() => {}}>
					{({ values, errors, touched, setFieldValue, handleBlur }) => {

						return (
							<Form>
								<div className='virtualCard'>
									<Cards
										cvc={values.cardCVV}
										expiry={values.cardExpiry}
										name={values.cardName}
										number={values.cardNumber}
										focused={this.renderSwitch(this.state.focus)}
										placeholders={{name: 'Nome Impresso'}}
										locale={{valid:'Valido até'}}

									/>
								</div>
								<FormField className=' inputHeight '>
									<CustomInputMask
										className={values.flagIcon}
										id='cardnumber'
										name='cardNumber'
										mask={values.maskCard}
										maskChar='_'
										onFocus={this.handleInputFocus}
										onChange={e => {
											this.setField(e, setFieldValue);
										}}
										onBlur={handleBlur}
										value={values.cardNumber}
										required
									/>
									<label
										htmlFor='cardnumber'
										className={values.cardNumber === '' ? 'subscriber' : ''}>
										Número do cartão
									</label>
									{(touched.cardNumber || this.props.fieldsTouched) &&
										errors.cardNumber && (
											<div className='error-msg'>
												<FiAlertCircle size={13} />
												<small className='credit-card-error'>
													{errors.cardNumber}
												</small>
											</div>
										)}
								</FormField>

								<div className=' inputHeight'>
									<FormField>
										<CustomInputMask
											className='form-control'
											id='cardnome'
											name='cardName'
											onFocus={this.handleInputFocus}
											onChange={e => {
												this.setField(e, setFieldValue);
											}}
											onBlur={e => {
												handleBlur(e);
												this.removeCardNameWhiteSpace(e, setFieldValue);
											}}
											value={values.cardName}
											required
										/>
										<label
											htmlFor='cardnome'
											className={values.cardName === '' ? 'subscriber' : ''}>
											Nome impresso no cartão
										</label>
										{(touched.cardName || this.props.fieldsTouched) &&
											errors.cardName && (
												<div className='error-msg'>
													<FiAlertCircle size={13} />
													<small className='credit-card-error'>
														{errors.cardName}
													</small>
												</div>
											)}
									</FormField>
								</div>
								<div className='form-size'>
									<div className='form-size-1 '>
										<FormField className=' inputHeight'>
											<CustomInputMask
												className='form-control'
												id='cardexpiry'
												name='cardExpiry'
												mask='99/99'
												maskChar='_'
												onFocus={this.handleInputFocus}
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.cardExpiry}
												required
											/>
											<label
												htmlFor='cardexpiry'
												className={
													values.cardExpiry === '' ? 'subscriber' : ''
												}>
												Validade
											</label>
											{(touched.cardExpiry || this.props.fieldsTouched) &&
												errors.cardExpiry && (
													<div className='error-msg'>
														<FiAlertCircle size={13} />
														<small className='credit-card-error'>
															{errors.cardExpiry}
														</small>
													</div>
												)}
										</FormField>
									</div>
									<div className='form-size-1  '>
										<FormField className=' inputHeight '>
											<CustomInputMask
												className='form-control'
												id='cardcvv'
												name='cardCVV'
												onFocus={this.handleInputFocus}
												mask={this.state.maskCvv} // aqui
												maskChar={null}
												onChange={e => {
													this.setField(e, setFieldValue);
												}}
												onBlur={handleBlur}
												value={values.cardCVV}
												required
											/>
											<label
												htmlFor='cardcvv'
												className={values.cardCVV === '' ? 'subscriber' : ''}>
												CVV
												<button
													type='button'
													className=' btn-cvv'
													data-toggle='tooltip'
													data-html='true'
													data-placement='top'
													title='<b>Código de Segurança</b>.<br/><br/> Para os
									cartões <b>Visa</b>, <b>Mastercard</b>,	<b>Hipercard</b> e
									<b>Elo</b> o código encontra-se no verso de
									seu cartão.<br/> Já para o <b>American Express</b> o código
									encontra-se na frente de seu cartão.'>
													<FaQuestion size={8} color={'#FFF'} />
												</button>
											</label>
											{(touched.cardCVV || this.props.fieldsTouched) &&
												errors.cardCVV && (
													<div className='error-msg'>
														<FiAlertCircle size={13} />
														<small className='credit-card-error'>
															{errors.cardCVV}
														</small>
													</div>
												)}
										</FormField>
									</div>
								</div>
								<FormField>
									{this.props.installments > 1 &&
										installmentElm({ values, setFieldValue, handleBlur })}
								</FormField>

								{/* data-cy='btn-slider' é ultilazada para selecionar o botão de confirmação de Termos, condições do produto e politica de privacidade em  testes desenvolvidos no cypress*/}
								<FormField>
									<FormField className='form-terms' data-cy='btn-slider'>
										{dependentIsActive == true && loja === 'qualicorp' && (
											<div style={{ marginTop: '-16px' }}>
												<h5>
													Essa compra é mensal/recorrente e não consome o limite
													do seu cartão de crédito.
												</h5>
											</div>
										)}
										<TermAndConditions
											changeTerm={this.changeTerm}
											handleBlur={handleBlur}
											setFieldValue={setFieldValue}
											signatureChosen={SignatureChosen.data}
										/>

										{(touched.termos1 || this.props.fieldsTouched) &&
											errors.termos1 && (
												<div className='error-msg'>
													<FiAlertCircle size={13} />
													<small className='credit-card-error'>
														{errors.termos1}
													</small>
												</div>
											)}
									</FormField>
								</FormField>
								{/*<pre>{JSON.stringify(this.state)}</pre>
								<pre>{JSON.stringify(values)}</pre>*/}
							</Form>
						);
					}}
				</Formik>
			</div>
		);
	}
}

export default FormCreditCard;

export function CustomInputMask(props) {
	const [field] = useField({
		type: 'text',
		id: props.id,
		name: props.name,
		mask: props.mask,
		maskChar: props.maskChar,
		validate: props.validate
	});
	return (
		<InputMask
			{...props}
			{...field}
			className={props.className}
			onChange={props.onChange}
			onBlur={props.onBlur}
			value={props.value}
		/>
	);
}
